export const ciclosStyles = {}
